export enum GuestInviteStatus {
  Accepted = "accept",
  Rejected = "reject",
  Pending = "pending",
}

export type GuestDataItem = {
  name: GuestInviteStatus;
  value?: number;
};

export type GuestDataItemSimple = {
  title: GuestInviteStatus;
  value?: number;
};

export type GuestDataItemGrid = {
  name: GuestInviteStatus;
  value: number;
};

export const GuestInviteStatusMap = {
  [GuestInviteStatus.Accepted]: {
    color: "#54C080",
    text: "Confirmed",
  },
  [GuestInviteStatus.Rejected]: {
    color: "#BB2727",
    text: "Declined",
  },
  [GuestInviteStatus.Pending]: {
    color: "#e0ac2b",
    text: "Pending",
  },
};

export enum MessagingStatus {
  Sent = "sent",
  Opened = "opened",
}

export type MessageDataItem = {
  name: MessagingStatus;
  value?: number;
};

export type MessageDataItemSimple = {
  title: MessagingStatus;
  value?: number;
};

export type EventNavProps = {
  text?: string;
};

export const MessagingStatusMap = {
  [MessagingStatus.Sent]: {
    color: "#C0B354",
    text: "Sent",
  },
  [MessagingStatus.Opened]: {
    color: "#54C080",
    text: "Opened",
  },
};

export enum RSVPComingFor {
  Bride = "bride",
  Groom = "groom",
  Both = "both",
}

export enum InviteType {
  Physical = "physical",
  Digital = "digital",
}

export const getRSVPComingForOptions = (comingFor: RSVPComingFor) => {
  const data: Record<RSVPComingFor, { text: string; value: string }> = {
    [RSVPComingFor.Bride]: {
      text: "Bride",
      value: RSVPComingFor.Bride,
    },
    [RSVPComingFor.Groom]: {
      text: "Groom",
      value: RSVPComingFor.Groom,
    },
    [RSVPComingFor.Both]: {
      text: "Bride | Groom",
      value: RSVPComingFor.Both,
    },
  };
  return data[comingFor];
};

export const getInviteTypeOptions = (inviteType: InviteType) => {
  const data: Record<InviteType, { text: string; value: string }> = {
    [InviteType.Physical]: {
      text: "Physical",
      value: InviteType.Physical,
    },
    [InviteType.Digital]: {
      text: "Digital",
      value: InviteType.Digital,
    },
  };
  return data[inviteType];
};

export type MailReceipts = {
  guestinvite?: number;
  accesscard?: number;
  thankyounote?: number;
  rsvpreminder?: number;
  countdown?: number;
};

export type WhatsAppReceipts = {
  guestinvite?: number;
  thankyounote?: number;
  rsvpreminder?: number;
  countdown?: number;
};

export type Guest = {
  _id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  eventPlannerID: string;
  accessCardAddress: string;
  rsvpComingFor: RSVPComingFor;
  rsvpRelationship: string;
  weddingID: string;
  events: string[];
  inviteStatus: GuestInviteStatus;
  additionalGuestLimit: number;
  primaryGuestID?: string;
  invitationPartyID?: string;
  inviteType: string;
  eventWeddingTables: Record<string, string>;
  eventQrCodeCloudinaryURL: Record<string, string>;
  createdAt: string;
  meta: Record<string, unknown>;
  mailReceipts?: MailReceipts;
  whatsAppReceipts?: WhatsAppReceipts;
};

export type GuestAndIsChecked = Guest & {
  isChecked: boolean;
};

export type DeletedGuest = {
  _id: string;
  guest: Guest;
  createdAt: Date;
  updatedAt: Date;
};
